module.exports = __webpack_public_path__ + "static/scroll_heatmap_explore-40fe787950acd39ccc59d5e4c56fd06f.jpg";